import { useEffect, useRef } from "preact/hooks";
import { ComponentChildren } from "preact";

import { Container } from "@components/ui/structure/container";
import { useClasses } from "@styles";

interface InputProps {
  name?: string | null;
  leftChildren?: ComponentChildren;
  rightChildren?: ComponentChildren;
  className?: string;
  containerClassName?: string;
  placeholder?: string;
  defaultValue?: string;
  inputType?: "text" | "password" | "email" | "number" | "tel";
  autoFocus?: boolean;
  onInput?: (value: string) => void;
  onEnter?: () => void;
}

export function Input({
  name = null,
  leftChildren = null,
  rightChildren = null,
  placeholder = "",
  className = "",
  containerClassName = "",
  defaultValue = "",
  inputType = "text",
  autoFocus = true,
  onInput = () => {},
  onEnter = () => {},
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const inputElement = inputRef.current;

    if (!inputElement) return;
    if (inputElement !== document.activeElement)
      inputElement.setSelectionRange(
        defaultValue.length,
        defaultValue.length,
      );

    inputElement.focus();
  }, [defaultValue]);

  return (
    <Container
      className={useClasses("input-container") + " " + containerClassName}
    >
      {leftChildren}
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        name={name || undefined}
        className={useClasses("input") + " " + className}
        defaultValue={defaultValue}
        placeholder={placeholder}
        type={inputType}
        onInput={(e) => onInput((e.target as HTMLInputElement).value)}
        onKeyDown={(e) => e.key === "Enter" && onEnter()}
      />

      {rightChildren}
    </Container>
  );
}

